<style lang="scss" scoped>
/deep/ .comp-work-echart-dialog {
    margin-top: 5vh !important;
    width: 92%;
}
</style>

<template>
    <div>
        <el-dialog :title="title" custom-class="c-el-dialog comp-work-echart-dialog" :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false">
            <echart id="workEchart" title="" width="100%" height="70vh" :option="workEchartOption"></echart>
        </el-dialog>
    </div>
</template>

<script>
import echart from "@/components/Echarts/Index"
import * as funMaintenance from '@/api/maintenance'
import * as funEmployees from '@/api/employees'
import moment from "moment"
export default {
    name: "compWorkEchart",
    components: { echart },
    data() {
        return {
            title: "",
            showDialog: false,
            workData: {},
            legendData: ["有效挪车", "挪车量", "换电量", "维修量", "扫一扫"], // "巡检量", "扫一扫"
            workEchartOption: {}
        }
    },
    methods: {
        open(row) {
            if (!row || !row.id) {
                return false
            }
            this.workData = JSON.parse(JSON.stringify(row))
            this.title = `【${row.name}】${moment(row.date).format("YYYY-MM-DD")}的工作时间段数据统计`
            this.setWorkOptions()
            this.$nextTick(() => {
                this.loadEchartData()
            })
            this.showDialog = true
        },
        loadEchartData() {
            funEmployees.GetEmployeeHourWorkStatistics({
                date: moment(this.workData.date).format("YYYY-MM-DD"),
                telOrName: this.workData.tel,
            }).then(res => {
                if (res && res.length > 0) {
                    let item = res[0]
                    // 有效挪车量
                    for (let i in item.effectiveMoveTaskCount) {
                        this.workEchartOption.series[0].data.push(item.effectiveMoveTaskCount[i])
                    }
                    // 挪车量
                    for (let i in item.moveTaskCount) {
                        this.workEchartOption.series[1].data.push(item.moveTaskCount[i])
                    }
                    // 换电量
                    for (let i in item.batteryChangeTaskCount) {
                        this.workEchartOption.series[2].data.push(item.batteryChangeTaskCount[i])
                    }
                    // 维修量
                    for (let i in item.maintenanceTaskCount) {
                        this.workEchartOption.series[3].data.push(item.maintenanceTaskCount[i])
                    }
                    // 扫一扫
                    for (let i in item.scanTaskCount) {
                        this.workEchartOption.series[4].data.push(item.scanTaskCount[i])
                    }
                }
            })
        },
        setWorkOptions() {
            let xAxisData = []
            // 横坐标
            for (let i = 0; i < 24; i++) {
                xAxisData.push(`${i >= 10 ? i : '0' + i}:00`)
            }
            let series = this.legendData.map((x, i) => {
                return {
                    name: this.legendData[i],
                    type: "line",
                    data: []
                }
            })
            this.workEchartOption = {
                title: {
                    show: false,
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legendData
                },
                grid: {
                    left: '1%',
                    right: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                dataZoom: {
                    show: true,
                    // left: "3%",
                    // width: "90%",
                    start: 0,
                    end: 100
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    axisLabel: {
                        interval: 0,
                        // showMinLabel: true,
                        // showMaxLabel: true
                    },
                    data: xAxisData,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#e8e8e8"
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        axisTick: {},
                        axisLabel: {
                            formatter: "{value}"
                        }
                    }
                ],
                series: series
            }
        },
        _close() {
            this.showDialog = false
        }
    }
}
</script>